import { useState } from "react";
import Toolbar from "@mui/material/Toolbar";
import DateComponent from "./DateComponent";
import { marginBottom } from "../App";
import { Row } from "react-bootstrap";
//import "./Menu.css";

function VN() {
  const [color, setColor] = useState("success.main");

  return (
    <Row style={{ marginBottom }}>
      <Toolbar sx={{ backgroundColor: color, color: "white" }}>
        <DateComponent />
      </Toolbar>
    </Row>
  );
}
export default VN;
